export const DEACTIVATE_EMAIL_SMS_TOGGLE = {
  id: 'show-deactivate-email-sms',
  label: 'Show Deactivate Email/SMS Button',
  description:
    'Show the deactivation action at the bottom of tenant Engage settings. New partners default to enabled.',
};

export const ONBOARDING_AUTOMATIONS_DEFAULT_TOGGLE = {
  id: 'onboarding-automations-enabled-by-default',
  label: 'Turn On Automations by Default in Onboarding',
  description:
    'On the last step of Engage onboarding, start every automation switched on. When disabled, automations start switched off and users opt in to the ones they want. Defaults to enabled.',
};

export const ENGAGE_SETTINGS_COPY = {
  title: 'Engage Settings',
  description: 'Configure Engage feature settings for your users',
} as const;

export const SAVE_BAR_COPY = {
  saved: 'All changes saved',
  dirty: 'Unsaved changes',
  saving: 'Saving…',
  cancel: 'Cancel',
  save: 'Save Changes',
  statusLabel: 'Engage settings save status',
} as const;
